<template>
  <v-card flat class="pa-4">
    <v-row>
      <v-col cols="12" md="7">
        <div class="d-flex align-center mb-3">
          <v-chip small :color="secretConfigured ? 'green lighten-4' : 'orange lighten-4'"
                  :text-color="secretConfigured ? 'green darken-3' : 'orange darken-3'">
            {{ secretConfigured ? 'Compte KL Pay configuré' : 'Compte KL Pay non configuré' }}
          </v-chip>
        </div>

        <p class="text-caption grey--text mb-4">
          Administration : ces identifiants peuvent être modifiés ici même après
          configuration (le marchand, lui, est verrouillé une fois le compte configuré).
          Le secret n'est jamais réaffiché — laisser le champ vide conserve l'actuel.
        </p>

        <v-text-field
          v-model="apiKey"
          label="Clé API (api_key)"
          placeholder="klp_..."
          outlined
          dense
          autocomplete="off"
        ></v-text-field>

        <v-text-field
          v-model="apiSecret"
          :label="secretConfigured ? 'Secret API (laisser vide pour conserver l\'actuel)' : 'Secret API (api_secret)'"
          :placeholder="secretConfigured ? '••••••••••••' : ''"
          outlined
          dense
          :append-icon="showSecret ? 'mdi-eye-off' : 'mdi-eye'"
          :type="showSecret ? 'text' : 'password'"
          @click:append="showSecret = !showSecret"
          autocomplete="new-password"
        ></v-text-field>

        <v-btn color="secondary" :loading="saving" :disabled="!canSave" @click="save">
          <v-icon left small>mdi-check</v-icon>
          Enregistrer
        </v-btn>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :timeout="3500" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </v-card>
</template>

<script>
export default {
  name: 'KlPayView',
  props: {
    business: [],
  },
  data () {
    return {
      apiKey: '',
      apiSecret: '',
      showSecret: false,
      saving: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
    }
  },
  computed: {
    secretConfigured() {
      return !!(this.business && this.business.klpay_secret_configured)
    },
    canSave() {
      if (!this.apiKey) return false
      if (!this.secretConfigured && !this.apiSecret) return false
      return true
    },
  },
  watch: {
    business: {
      immediate: true,
      handler(biz) {
        if (biz && biz.klpay_api_key !== undefined) {
          this.apiKey = biz.klpay_api_key || ''
        }
      },
    },
  },
  methods: {
    save() {
      var payload = { klpay_api_key: this.apiKey.trim() }
      if (this.apiSecret) {
        payload.klpay_api_secret = this.apiSecret.trim()
      }
      var self = this
      this.saving = true
      this.$axios.put('/businesses/' + this.business.id + '?data=' + encodeURIComponent(JSON.stringify(payload)))
        .then(function () {
          self.saving = false
          self.apiSecret = ''
          if (self.business) self.business.klpay_secret_configured = true
          self.snackbarColor = 'success'
          self.snackbarText = 'Identifiants KL Pay enregistrés'
          self.snackbar = true
          self.$emit('refresh')
        })
        .catch(function (error) {
          self.saving = false
          self.snackbarColor = 'error'
          self.snackbarText = (error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : "Échec de l'enregistrement"
          self.snackbar = true
        })
    },
  },
}
</script>
